export const CONFIRMATION_MODAL = 'confirmationModal'

export const DUPLICATE_VEHICLE_ID = 'addCookieVehicle'

export const CONFIRMATION_DESCRIPTION = 'Would you like to add another similar vehicle in My Garage?'
